// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"9f0a0834","108":"e8da524e","251":"1d305ec3","318":"2e91bb5a","344":"741a0dda","345":"e650ee1a","381":"80c1e5b2","517":"d2449713","574":"c42a9f62","909":"5bac64c1","988":"e9b20058"}[chunkId] + ".chunk.js";
};